@use "~@optimizely/design-tokens/dist/scss/colors";

:host {
  --axiom-space-xsmall: 4px;
  --axiom-space-small: 8px;
  --axiom-space-medium: 12px;
  --axiom-space-large: 16px;
  --axiom-space-xlarge: 16px;
  --axiom-dropshadow-small: 0px 1px 4px rgba(0, 0, 0, 0.25);
  --axiom-border-radius-default: 5px;

  font-family: var(--axiom-font-families-inter);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.profile-dropdown-container {
  padding: 6px;
  width: hug(100%);
  height: hug(100%);
  position: relative;
}

.profile-dropdown-container:hover {
  background-color: #fff3;
  cursor: pointer;
}

.avatar {
  all: unset;
  border: solid;
  border-radius: 50%;
  border-width: 1px;
  width: 24px;
  height: 24px;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  position: relative;

  &__icon {
    margin-top: 3px;
    background: transparent;
    &:hover {
      cursor: pointer;
    }
    &:hover, &:focus-within {
      color: colors.$tile-hover-text-title-color
    }
  }

  &:hover, &:focus-within {
    color: colors.$tile-hover-text-title-color
  }
}

.profile-dropdown {
  box-shadow: var(--axiom-dropshadow-small);
  border-radius: var(--axiom-border-radius-default);
  display: flex;

  flex-direction: column;
  align-items: left;
  padding: 0;
  gap: 1px;
  position: relative;
  width: 200px;
  background: #FFFFFF;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  color: #080436;
  letter-spacing: -0.011em;
  position: absolute;
  top: calc(100% + 1px);
  right: 0;
  z-index: 100;

  .menu {
    .list-item-header {
      padding: var(--axiom-space-small) var(--axiom-space-medium);
      border-bottom: 1px solid colors.$block-list-divider-color;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .list-item-header {
      color: #707070;
      .name {
        color: #080436;
      }

      .email {
        font-size: 12px;
        line-height: 20px;
      }
    }

    .list-item {
      display: flex;
      align-items: center;
      padding: 0 var(--axiom-space-small);
      color: #0037FF;
      border-bottom: 1px solid colors.$block-list-divider-color;
      height: var(--axiom-dropdown-item-height);
    }

    .list-item:last-child {
      border-bottom: none;
    }

    .list-item-link {
      padding: 0 var(--axiom-space-small);
      text-decoration: none;
      color: colors.$link-default-text-color;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      white-space: nowrap;
      width: 100%;
    }

    .list-item-link:hover {
      background-color: colors.$brand-blue-extra-light;
      border-radius: var(--axiom-border-radius-default);
    }

    .list-item-icon {
      padding-right: var(--axiom-space-small);
      margin-top: 5px;
    }
  }
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.profile-dropdown {
  display: none;
}

.profile-dropdown-container:focus-within>.profile-dropdown {
  display: block;
}
